import L_HTML5 from "../images/skills/html-5.svg";
import L_CSS3 from "../images/skills/css3.svg";
import L_SASS from "../images/skills/sass-1.svg";
import L_BOOTSTRAP from "../images/skills/bootstrap-4.svg";
import L_REACT from "../images/skills/react.svg";
import L_REDUX from "../images/skills/redux.svg";
import L_REACT_ROUTER from "../images/skills/react-router.svg";
import L_MATERIALUI from "../images/skills/material-ui-1.svg";
//import L_REACT_BOOTSTRAP from "../images/skills/react-bootstrap.svg";
import L_NODE_JS from "../images/skills/nodejs.svg";
import L_EXPRESS from "../images/skills/express.svg";
import L_MONGODB from "../images/skills/mongodb.svg";
//import L_FIREBASE from "../images/skills/firebase-seeklogo.com.svg";
//import L_MSSQL from "../images/skills/mssql.svg";
import L_GIT from "../images/skills/git-icon.svg";
import L_HEROKU from "../images/skills/heroku.svg";
//import L_GITHUB_PAGES from "../images/skills/github.svg";
import L_JAVASCRIPT from "../images/skills/javascript.svg";
import L_TYPESCRIPT from "../images/skills/typescript.svg";
//import L_NETLIFY from "../images/skills/netlify.svg";
import L_PYTHON from "../images/skills/python.svg";



export const SkillsData = {
  frontend: [
    {
      Title: "Basics",
      skillsInfo: [
        {
      link: "https://en.wikipedia.org/wiki/HTML5",
      imgAltText: "HTML 5",
      imgSrc: L_HTML5,
      skillName: "HTML5",
    },
    {
      link: "https://medium.com/beginners-guide-to-mobile-web-development/whats-new-in-css-3-dcd7fa6122e1",
      imgAltText: "CSS 3",
      imgSrc: L_CSS3,
      skillName: "CSS3",
    },
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
        }
      ]
    },
    {
      Title: "Frameworks/Libraries",
      skillsInfo: [
        {
      link: "https://reactjs.org/",
      imgAltText: "React JS",
      imgSrc: L_REACT,
      skillName: "React JS",
    },
    {
      link: "https://redux.js.org/",
      imgAltText: "Redux",
      imgSrc: L_REDUX,
      skillName: "Redux",
    },
    {
      link: "https://reacttraining.com/react-router/",
      imgAltText: "React Router",
      imgSrc: L_REACT_ROUTER,
      skillName: "React Router",
    }
      ]
    },
    {
      Title: "Styles",
      skillsInfo: [
        {
      link: "https://sass-lang.com/",
      imgAltText: "Sass",
      imgSrc: L_SASS,
      skillName: "Sass",
    },
    {
      link: "https://getbootstrap.com/",
      imgAltText: "Bootstrap",
      imgSrc: L_BOOTSTRAP,
      skillName: "Bootstrap",
    },
    
    {
      link: "https://material-ui.com/",
      imgAltText: "Material-UI",
      imgSrc: L_MATERIALUI,
      skillName: "Material-UI",
    },    
    {
      link: "https://styled-components.com/",
      imgAltText: "styled-components",
      imgSrc: "https://styled-components.com/logo.png",
      skillName: "styled-components",
    },
      ]
    },
  ],

  backend: [
    {
      link: "https://nodejs.org/en/",
      imgAltText: "Node.js",
      imgSrc: L_NODE_JS,
      skillName: "Node.js",
    },
    {
      link: "https://expressjs.com/",
      imgAltText: "Express",
      imgSrc: L_EXPRESS,
      skillName: "Express",
    },

  ],
  hostingPlatforms: [
    {
      link: "https://www.heroku.com/",
      imgAltText: "Heroku",
      imgSrc: L_HEROKU,
      skillName: "Heroku",
    },
    {
      link: "https://en.wikipedia.org/wiki/Microsoft_Azure",
      imgAltText: "Microsoft Azure",
      imgSrc: "https://dzone.com/storage/temp/12165862-azurelogo-1.png",
      skillName: "Microsoft Azure",
    },
    {
      link: "https://pages.github.com/",
      imgAltText: "Netlify",
      imgSrc: "https://avatars0.githubusercontent.com/u/7892489?s=200&v=4",
      skillName: "Netlify",
    },
  ],
  programmingLanguages: [
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },
    {
      link: "https://www.typescriptlang.org/",
      imgAltText: "TypeScript",
      imgSrc: L_TYPESCRIPT,
      skillName: "TypeScript",
    },
    {
      link: "https://www.python.org/",
      imgAltText: "Python",
      imgSrc: L_PYTHON,
      skillName: "Python",
    },

  ],
  databases: [
    {
      link: "https://www.mongodb.com/",
      imgAltText: "MongoDB",
      imgSrc: L_MONGODB,
      skillName: "MongoDB",
    },
    {
      link: "https://www.postgresql.org/",
      imgAltText: "PostgreSQL",
      imgSrc: "https://www.postgresql.org/media/img/about/press/elephant.png",
      skillName: "PostgreSQL",
    },

  ],
  versionControl: [
    {
      link: "https://git-scm.com/",
      imgAltText: "GIT",
      imgSrc: L_GIT,
      skillName: "GIT",
    },
  ],
};

export default SkillsData;